var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Button, Divider, Grid, Stack, styled, TextField, Typography, useMediaQuery, useTheme } from "@mui/material";
import { t } from "i18next";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AlternatePartConfigUrl, APPLICATION_SETTINGS, assignedMenusByGroupURL, assignedModulesURL, DeclinedJobConfigurationSettingURL, getBranchChannelUrl, getChannelSettings, getChannelSettingByKey, getDelayJobCardConfigurationURL, getIdentityPersonalizationListUrl, getProductIssueConfigurationURL, getRepeatRevisitReasonListURL, getRepeatRevisitReasonListURL_MC, organizationStartEndTimeURL, ServiceTypeListURL, technicianListAPI, USER_PROFILE_DATA, USER_ROLE, WOH_AM_I_DATA } from "../../api/url";
import { BajajDrawerLogoIcon, BrandLogoIcon } from "../../assets/customIcons";
import { MuiLoaderButton } from "../../components/atoms/loaderButton";
import SliderCarousel from "../../components/atoms/sliderCarousel";
import { MuiButton, MuiForm, MuiPopup, MuiStack } from "../../components/index";
import dayjs from "dayjs";
import { env } from "../../api/config";
import { AlertRedIcon, ExcellonLogo } from "../../assets/images";
import { setRbacStorage } from "../../builderPackage/rbac/rbac.entity";
import { dateBeforeMonth, dateBeforeWeek, E_Channel_Name, EUserRole, isModuleConfig, LOCAL_STORAGE_KEYS, LoginOtpTimer, Module, SPARE_ISSUE_ENUM, UCN_MAP_KEYS, versionNum } from "../../constants";
import { getApplicationSetting, loginAPI, verifyOtpAPI, whoAmIAPI } from "../../redux/authSlice";
import { resetCommonReducer, setBranchChannelList, showLoader, showNotification } from "../../redux/commonSlice";
import { getByIdAPI, getListAPI } from "../../redux/crudSlice";
import { saveChannelIdDetails } from "../../redux/profileSlice";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { systemColor } from "../../theme/systemColor";
import { clearLocalStorage, getLocalStorageItem, setLocalStorageItem } from "../../utils/storageHelper";
import { TimeZoneDialog } from "../../utils/timeZoneDialog";
import useAnalyticsEventTracker from "../../utils/useAnalyticsEventTracker";
import { formatTime, GoogleAnlyticsErrorLog, handleMobileNoPhoneCall, handleServerSideErrors, transactionEventLog } from "../../utils/utils";
import { isValidMobileNumber, REG } from "../../utils/validationHelper";
import { ChitraLogin } from "../reports/utils";
var LoginForm = styled(MuiForm)(function (_ref) {
    var theme = _ref.theme;
    return {
        //. height: '100vh',
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center"
    };
});
// alert("DEBUGGING  ISSUE .")
var Login = function (props) {
    var _JSON$parse;
    var dispatch = useAppDispatch();
    var theme = useTheme();
    var whoamiData = getLocalStorageItem(WOH_AM_I_DATA);
    var navigate = useNavigate();
    var auth = localStorage.getItem(LOCAL_STORAGE_KEYS.USER_LOGIN_DATA);
    var userRole = localStorage.getItem(USER_ROLE);
    var userProfile = localStorage.getItem(USER_PROFILE_DATA);
    var applicationSetting = localStorage.getItem(APPLICATION_SETTINGS);
    var trackButtonClick = useAnalyticsEventTracker("Login");
    var timerCount = applicationSetting ? Number((_JSON$parse = JSON.parse(applicationSetting !== null && applicationSetting !== void 0 ? applicationSetting : "")) === null || _JSON$parse === void 0 || (_JSON$parse = _JSON$parse.data) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.OTPExpireTime) : LoginOtpTimer;
    var _a = useState(""), mobileNumber = _a[0], setMobileNo = _a[1];
    var _b = useState(""), otp = _b[0], setOpt = _b[1];
    var _c = useState({
        isValidMobileNumber: "",
        isValidOTP: ""
    }), errorMessage = _c[0], setErrorMessage = _c[1];
    var _d = useState(false), isErrorOccure = _d[0], setIsErrorOccure = _d[1];
    var _e = useState(false), isErrorOccureOtp = _e[0], setIsErrorOccureOtp = _e[1];
    var _f = useState(timerCount), counter = _f[0], setCounter = _f[1];
    var _g = useState(false), isCounterActive = _g[0], setIsCounterActive = _g[1];
    var _h = useState(false), isOtpSent = _h[0], setIsOtpSent = _h[1];
    var storedChannelList = getLocalStorageItem(LOCAL_STORAGE_KEYS.CHANNEL_LIST);
    var storedIdentityPersonalizationList = getLocalStorageItem(LOCAL_STORAGE_KEYS.IDENTITY_PERSONALIZATION_LIST);
    var selectedDesignationStorage = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_DESIGNATION);
    var loader = useAppSelector(function (state) { return state.common.isLoader; });
    var assignedMenus = useSelector(function (state) { return state.common; }).assignedMenus;
    var IS_DESKTOP = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var upSM = useMediaQuery(function (theme) { return theme.breakpoints.up("sm"); });
    var dowMd = useMediaQuery(function (theme) { return theme.breakpoints.down("md"); });
    var IS_TABLET = upSM && dowMd;
    var upXS = useMediaQuery(function (theme) { return theme.breakpoints.up("xs"); });
    var downSM = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var IS_MOBILE = upXS && downSM;
    var _j = useState(false), openUnauthorizedPopup = _j[0], setOpenUnauthorizedPopup = _j[1];
    useEffect(function () {
        // window.history.pushState(null, window.location.href);
        // window.onpopstate = function (event) {
        //   window.history.go(0);
        // };
        // alert("Calling who am i.")
        whoamiApi();
        // forceRefresh()
    }, []);
    var _k = useState(false), showPopup = _k[0], setShowPopup = _k[1];
    var validZones = new Set(["Asia/Kolkata", "Asia/Calcutta"]);
    var expectedOffset = "+05:30";
    var expectedLabel = "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi";
    var getTimeZoneValidation = function () {
        var detectedZone = dayjs.tz.guess();
        var offset = dayjs().tz(detectedZone).format("Z");
        var isValid = validZones.has(detectedZone) && offset === expectedOffset;
        return {
            isValid: isValid,
            detectedZone: detectedZone,
            offset: offset,
            expectedOffset: expectedOffset,
            expectedLabel: expectedLabel
        };
    };
    var timeZoneCheck = getTimeZoneValidation();
    useEffect(function () {
        setShowPopup(!timeZoneCheck.isValid);
    }, [timeZoneCheck.isValid]);
    var handleUpdate = function () {
        window.open("ms-settings:dateandtime", "_blank");
        setShowPopup(false);
    };
    var handleRemindLater = function () {
        setShowPopup(false);
    };
    useEffect(function () {
        if (auth && userProfile) {
            // getModulesData();
            var variant = (selectedDesignationStorage === null || selectedDesignationStorage === void 0 ? void 0 : selectedDesignationStorage.Name) == EUserRole.FinalInspector ? "Job card" : "Appointments";
            setLocalStorageItem(LOCAL_STORAGE_KEYS.DASHBOARD_SELECTED_VARIANT, variant);
            setLocalStorageItem(LOCAL_STORAGE_KEYS.FILTER_FROM_DATE, dateFormate((selectedDesignationStorage === null || selectedDesignationStorage === void 0 ? void 0 : selectedDesignationStorage.Name) === EUserRole.FloorSupervisor ? dateBeforeMonth : dateBeforeWeek));
            setLocalStorageItem(LOCAL_STORAGE_KEYS.FILTER_TO_DATE, dateFormate(new Date()));
            navigate("/dashboard");
        }
    }, [auth]);
    useEffect(function () {
        var timer;
        if (isCounterActive && counter > 0) {
            timer = setInterval(function () {
                setCounter(function (prevCounter) { return prevCounter - 1; });
            }, 1000);
        }
        return function () { return clearInterval(timer); };
    }, [isCounterActive, counter]);
    var saveUcnConditionData = function (data) {
        var _a;
        var UCN_MAP_ITEM = (_a = {},
            _a[UCN_MAP_KEYS.UCN_CODE_TRANSACTION_TYPE] = "",
            _a[UCN_MAP_KEYS.UCN_CODE_SOURCE] = "",
            _a[UCN_MAP_KEYS.UCN_CODE_OPTIONS] = "",
            _a[UCN_MAP_KEYS.UCN_CODE_SERVICE_TYPE] = "",
            _a[UCN_MAP_KEYS.UCNSenderName] = "",
            _a[UCN_MAP_KEYS.IsSendUCNDisabled] = "",
            _a);
        for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
            var dataTypeItem = data_1[_i];
            if (dataTypeItem.Key in UCN_MAP_KEYS) {
                UCN_MAP_ITEM[dataTypeItem.Key] = dataTypeItem.Value;
            }
        }
        setLocalStorageItem(LOCAL_STORAGE_KEYS.UCN_MAP, UCN_MAP_ITEM);
    };
    var getModulesData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var resultedRole, _assignedModule$paylo, _assignedModule$paylo2, request, assignedModule, _assignedModule$paylo3, _moduleMenuListRespon, _moduleMenuListRespon2, body, moduleMenuListResponse, _moduleMenuListRespon3, _moduleMenuListRespon4, updatedList;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    resultedRole = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_DESIGNATION);
                    if (!resultedRole) return [3 /*break*/, 3];
                    request = {
                        RoleId: resultedRole.RoleId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: assignedModulesURL,
                            request: request
                        }))];
                case 1:
                    assignedModule = _a.sent();
                    if (!(assignedModule !== null && assignedModule !== void 0 && (_assignedModule$paylo = assignedModule.payload) !== null && _assignedModule$paylo !== void 0 && (_assignedModule$paylo = _assignedModule$paylo.value) !== null && _assignedModule$paylo !== void 0 && _assignedModule$paylo.success && (assignedModule === null || assignedModule === void 0 || (_assignedModule$paylo2 = assignedModule.payload) === null || _assignedModule$paylo2 === void 0 || (_assignedModule$paylo2 = _assignedModule$paylo2.value) === null || _assignedModule$paylo2 === void 0 ? void 0 : _assignedModule$paylo2.data.length) > 0)) return [3 /*break*/, 3];
                    body = {
                        ModuleId: assignedModule === null || assignedModule === void 0 || (_assignedModule$paylo3 = assignedModule.payload) === null || _assignedModule$paylo3 === void 0 || (_assignedModule$paylo3 = _assignedModule$paylo3.value) === null || _assignedModule$paylo3 === void 0 ? void 0 : _assignedModule$paylo3.data[0].ModuleId,
                        RoleId: resultedRole.RoleId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "assignMenusByGroupData",
                            url: assignedMenusByGroupURL,
                            request: body
                        }))];
                case 2:
                    moduleMenuListResponse = _a.sent();
                    if (moduleMenuListResponse !== null && moduleMenuListResponse !== void 0 && (_moduleMenuListRespon = moduleMenuListResponse.payload) !== null && _moduleMenuListRespon !== void 0 && _moduleMenuListRespon.value.success && moduleMenuListResponse !== null && moduleMenuListResponse !== void 0 && (_moduleMenuListRespon2 = moduleMenuListResponse.payload) !== null && _moduleMenuListRespon2 !== void 0 && (_moduleMenuListRespon2 = _moduleMenuListRespon2.value) !== null && _moduleMenuListRespon2 !== void 0 && _moduleMenuListRespon2.data) {
                        setRbacStorage(moduleMenuListResponse === null || moduleMenuListResponse === void 0 || (_moduleMenuListRespon3 = moduleMenuListResponse.payload) === null || _moduleMenuListRespon3 === void 0 || (_moduleMenuListRespon3 = _moduleMenuListRespon3.value) === null || _moduleMenuListRespon3 === void 0 ? void 0 : _moduleMenuListRespon3.data);
                        updatedList = moduleMenuListResponse === null || moduleMenuListResponse === void 0 || (_moduleMenuListRespon4 = moduleMenuListResponse.payload) === null || _moduleMenuListRespon4 === void 0 || (_moduleMenuListRespon4 = _moduleMenuListRespon4.value) === null || _moduleMenuListRespon4 === void 0 || (_moduleMenuListRespon4 = _moduleMenuListRespon4.data) === null || _moduleMenuListRespon4 === void 0 ? void 0 : _moduleMenuListRespon4.map(function (item) { return _objectSpread(_objectSpread({}, item), {}, {
                            isSubMenuOpen: false
                        }); });
                        setLocalStorageItem(LOCAL_STORAGE_KEYS.ASSIGNED_MENUS, updatedList);
                    }
                    else {
                        setLocalStorageItem(LOCAL_STORAGE_KEYS.ASSIGNED_MENUS, []);
                    }
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var whoamiApi = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _result$payload, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(whoAmIAPI(null))];
                case 1:
                    result = _a.sent();
                    if (!(result !== null && result !== void 0 && (_result$payload = result.payload) !== null && _result$payload !== void 0 && _result$payload.success)) return [3 /*break*/, 3];
                    return [4 /*yield*/, dispatch(getApplicationSetting(null))];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleOnChange = function (event) {
        var mobileLength = applicationSetting ? JSON.parse(applicationSetting !== null && applicationSetting !== void 0 ? applicationSetting : "").data.MobileLength : 10;
        var value = event.target.value;
        value = value.replace(REG.nonNumericNumber, "");
        // value = value.slice(0, 10);
        if (value.charAt(0) == '0') {
            setMobileNo(value);
            setErrorMessage(_objectSpread(_objectSpread({}, errorMessage), {}, {
                isValidMobileNumber: "Entered mobile number is incorrect",
                isValidOTP: ""
            }));
            setIsErrorOccure(true);
        }
        else {
            setMobileNo(value);
            setErrorMessage(_objectSpread(_objectSpread({}, errorMessage), {}, {
                isValidMobileNumber: "",
                isValidOTP: ""
            }));
            setIsErrorOccure(false);
            setIsCounterActive(false);
            setIsOtpSent(false);
            setCounter(timerCount);
            setOpt("");
        }
    };
    var handleOTPChange = function (event) {
        var value = event.target.value;
        value = value.replace(REG.nonNumericNumber, "");
        var otpLength = applicationSetting ? JSON.parse(applicationSetting !== null && applicationSetting !== void 0 ? applicationSetting : "").data.OTPLength : 4;
        value = value.slice(0, otpLength);
        setOpt(value);
        setErrorMessage(_objectSpread(_objectSpread({}, errorMessage), {}, {
            isValidOTP: ""
        }));
        setIsErrorOccureOtp(false);
    };
    var handleLogin = function (e, type) { return __awaiter(void 0, void 0, void 0, function () {
        var _result$payload2, body, result, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    if (type === 'send') {
                        trackButtonClick("ButtonClickEvent", "SendOtpClick", undefined);
                    }
                    else {
                        trackButtonClick("ButtonClickEvent", "ResendOtpClick", undefined);
                    }
                    if (!!isValidMobileNumber(mobileNumber)) return [3 /*break*/, 1];
                    setErrorMessage(_objectSpread(_objectSpread({}, errorMessage), {}, {
                        isValidMobileNumber: t("Enter Valid Mobile Number")
                    }));
                    setIsErrorOccure(true);
                    return [3 /*break*/, 4];
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    if (!(timeZoneCheck !== null && timeZoneCheck !== void 0 && timeZoneCheck.isValid)) {
                        setShowPopup(true);
                        return [2 /*return*/];
                    }
                    ;
                    body = {
                        MobileNo: mobileNumber
                    };
                    return [4 /*yield*/, dispatch(loginAPI(body))];
                case 2:
                    result = _a.sent();
                    if ((result === null || result === void 0 || (_result$payload2 = result.payload) === null || _result$payload2 === void 0 ? void 0 : _result$payload2.statusCode) === 200) {
                        setIsCounterActive(true);
                        setIsOtpSent(true);
                        setCounter(timerCount);
                        setOpt("");
                        setErrorMessage(_objectSpread(_objectSpread({}, errorMessage), {}, {
                            isValidMobileNumber: ""
                        }));
                        setIsErrorOccure(false);
                    }
                    else {
                        setErrorMessage(_objectSpread(_objectSpread({}, errorMessage), {}, {
                            isValidMobileNumber: handleServerSideErrors(result === null || result === void 0 ? void 0 : result.payload)
                        }));
                        setIsErrorOccure(true);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var SetDiable = function () {
        if (otp && mobileNumber) {
            return !mobileNumber && !otp;
        }
        else {
            return true;
        }
    };
    var formateDdMm = function (item) {
        if (item < 10) {
            return "0".concat(item);
        }
        else {
            return item;
        }
    };
    var dateFormate = function (date) {
        var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        var objectDate = new Date(date);
        var d = objectDate.getDate();
        var month = monthNames[objectDate.getMonth()];
        var y = objectDate.getFullYear();
        var dd = formateDdMm(d);
        return "".concat(month, " ").concat(dd, ", ").concat(y);
    };
    var handleSignInClick = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var otpLength, request, response, _response$payload, _response$payload2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    trackButtonClick("ButtonClickEvent", "SignInClick", undefined);
                    otpLength = applicationSetting ? JSON.parse(applicationSetting !== null && applicationSetting !== void 0 ? applicationSetting : "").data.OTPLength : 4;
                    if (!(otp.length != otpLength)) return [3 /*break*/, 1];
                    setErrorMessage(_objectSpread(_objectSpread({}, errorMessage), {}, {
                        isValidOTP: "Please enter ".concat(otpLength, " digit OTP.")
                    }));
                    setIsErrorOccureOtp(true);
                    return [3 /*break*/, 3];
                case 1:
                    request = {
                        MobileNo: mobileNumber,
                        VerificationCode: otp
                    };
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    return [4 /*yield*/, dispatch(verifyOtpAPI(request))];
                case 2:
                    response = _a.sent();
                    try {
                        if ((response === null || response === void 0 || (_response$payload = response.payload) === null || _response$payload === void 0 ? void 0 : _response$payload.statusCode) === 200 || response !== null && response !== void 0 && (_response$payload2 = response.payload) !== null && _response$payload2 !== void 0 && _response$payload2.success) {
                            // const profileDetailsResponse: any = await dispatch(getByIdAPI({ key: "", url: getUserProfileUrl }))
                            // console.log('LOGIN getUserProfileUrl')
                            // if (profileDetailsResponse?.payload?.success && profileDetailsResponse.payload.statusCode == 200 && profileDetailsResponse?.payload?.data?.AssignedRole?.length > 0) {
                            //   setLocalStorageItem(USER_PROFILE_DATA, profileDetailsResponse?.payload)
                            // }
                            if (env === "dev" || env === "lt") {
                                ChitraLogin(response, dispatch);
                            }
                            getIdentityPersonalizationList();
                            // const userRolesResponse = await dispatch(getProfilePersonalDetails(null))
                            // if (userRolesResponse?.payload?.success && userRolesResponse.payload.statusCode == 200 && userRolesResponse?.payload?.data?.AssignedRole?.length > 0) {
                            //   navigate('/dashboard')
                            //   setLocalStorageItem(USER_PROFILE_DATA, userRolesResponse?.payload)
                            //   const base64: any = await downloadProfileAttachment(userRolesResponse?.payload?.data?.IdentityId, userRolesResponse?.payload?.data?.AttachmentId, DownloadProfilePicUrl)
                            //   if (base64) {
                            //     dispatch(setProfilePic(base64))
                            //   }
                            // dispatch(
                            //   showNotification({
                            //     isOpen: true,
                            //     message: t("Logged in successfully"),
                            //     type: "success",
                            //   })
                            // );
                            // } else {
                            //   setIsCounterActive(false)
                            //   setIsOtpSent(false);
                            //   setCounter(timerCount);
                            //   setOpt('')
                            //   setMobileNo('')
                            //   dispatch(showNotification({ isOpen: true, message: "Role is not configured in the system, please configure the role against this user.", type: "error" }))
                            // }
                        }
                        else {
                            // const profileData = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)
                            // GoogleAnlyticsErrorLog(profileData, 'ClientSide', handleServerSideErrorsForAnalytics(response?.payload.data))
                            dispatch(showNotification({
                                isOpen: true,
                                message: handleServerSideErrors(response === null || response === void 0 ? void 0 : response.payload.data),
                                type: "error"
                            }));
                            dispatch(showLoader({
                                isLoaderOpen: false
                            }));
                        }
                    }
                    catch (error) {
                        console.error("Error", error);
                    }
                    _a.label = 3;
                case 3:
                    // mixpanel.track(`user_action` + ` / ${mobileNumber}`, {
                    //   user_name: mobileNumber,
                    //   date_and_time: new Date().toISOString(),
                    //   page_location: window.location.href, // Optional
                    // });
                    // window.gtag("event", "user_action", {
                    //   user_name: mobileNumber,
                    //   date_and_time: new Date().toISOString(),
                    //   page_location: window.location.href, // Optional
                    // });
                    transactionEventLog("user_action / ".concat(mobileNumber), {
                        user_name: mobileNumber,
                        date_and_time: new Date().toISOString(),
                        page_location: window.location.href // Optional
                    }, null);
                    return [2 /*return*/];
            }
        });
    }); };
    var getOrganizationTiming = function (organizationDetails) { return __awaiter(void 0, void 0, void 0, function () {
        var body, result, _result$payload$value, _result$payload$value2, StartDateTime, EndDateTime;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    body = {
                        OrganizationId: organizationDetails.OrganizationId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: organizationStartEndTimeURL,
                            request: body
                        }))];
                case 1:
                    result = _a.sent();
                    if (result.payload.value.success && result.payload.value.data) {
                        StartDateTime = (_result$payload$value = result.payload.value.data.find(function (item) { return item.AttributeName === "StartDateTime"; })) === null || _result$payload$value === void 0 ? void 0 : _result$payload$value.Value;
                        EndDateTime = (_result$payload$value2 = result.payload.value.data.find(function (item) { return item.AttributeName === "EndDateTime"; })) === null || _result$payload$value2 === void 0 ? void 0 : _result$payload$value2.Value;
                        setLocalStorageItem(LOCAL_STORAGE_KEYS.ORGANIZATION_TIMING, {
                            StartDateTime: StartDateTime,
                            EndDateTime: EndDateTime
                        });
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getTechnicianList = function (params) { return __awaiter(void 0, void 0, void 0, function () {
        var _getLocalStorageItem, _res$payload, _res$payload2, _a, key, _b, request, _c, url, state, res;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _a = params.key, key = _a === void 0 ? 'technicianList' : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? technicianListAPI : _c, state = params.state;
                    request.WorkingOrganizationId = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH)) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.OrganizationId;
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: key,
                            url: url,
                            request: request
                        }))];
                case 1:
                    res = _d.sent();
                    setLocalStorageItem(LOCAL_STORAGE_KEYS.TECHNICAIN_LIST, res === null || res === void 0 || (_res$payload = res.payload) === null || _res$payload === void 0 || (_res$payload = _res$payload.value) === null || _res$payload === void 0 ? void 0 : _res$payload.data);
                    return [2 /*return*/, res === null || res === void 0 || (_res$payload2 = res.payload) === null || _res$payload2 === void 0 ? void 0 : _res$payload2.value];
            }
        });
    }); };
    var getSettingsByChannel = function () { return __awaiter(void 0, void 0, void 0, function () {
        var result, _result$payload3, _result$payload4, findMobileNoRegexAttribute, DATE_FILTER_RESTRICTION, SUGGESTIONS_REQUIRED_COUNT, TRNTBikeProductCode, Tech_Pack_Exclude_Part, isEmailVerifiedAttribute;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(getByIdAPI({
                        key: "",
                        url: getChannelSettings
                    }))];
                case 1:
                    result = _a.sent();
                    if (result.payload.success && result.payload.data) {
                        getServiceTypeList();
                        fetchChannelSettingByKey();
                        setLocalStorageItem("ByChannelId", (_result$payload3 = result.payload) === null || _result$payload3 === void 0 ? void 0 : _result$payload3.data);
                        findMobileNoRegexAttribute = result.payload.data.find(function (item) { return item.Key === "MOBILE_NO_REGEX"; });
                        DATE_FILTER_RESTRICTION = result.payload.data.find(function (item) { return item.Key === "DATE_FILTER_RESTRICTION"; });
                        SUGGESTIONS_REQUIRED_COUNT = result.payload.data.find(function (item) { return item.Key === "Suggestions_Required_Count"; });
                        TRNTBikeProductCode = result.payload.data.find(function (item) { return item.Key === "TRNTBikeProductCode"; });
                        if (TRNTBikeProductCode) {
                            setLocalStorageItem(LOCAL_STORAGE_KEYS.TRNTBikeProductCode, TRNTBikeProductCode);
                        }
                        Tech_Pack_Exclude_Part = result.payload.data.find(function (item) { return item.Key === LOCAL_STORAGE_KEYS.Tech_Pack_Exclude_Part; });
                        if (Tech_Pack_Exclude_Part) {
                            setLocalStorageItem(LOCAL_STORAGE_KEYS.Tech_Pack_Exclude_Part, Tech_Pack_Exclude_Part);
                        }
                        if (DATE_FILTER_RESTRICTION) {
                            setLocalStorageItem(LOCAL_STORAGE_KEYS.DATE_FILTER_RESTRICTION, DATE_FILTER_RESTRICTION);
                        }
                        if (SUGGESTIONS_REQUIRED_COUNT) {
                            setLocalStorageItem(LOCAL_STORAGE_KEYS.SUGGESTIONS_REQUIRED_COUNT, SUGGESTIONS_REQUIRED_COUNT);
                        }
                        saveUcnConditionData(result.payload.data);
                        if (findMobileNoRegexAttribute) {
                            setLocalStorageItem(LOCAL_STORAGE_KEYS.MOBILE_NO_REGEX, findMobileNoRegexAttribute.Value);
                        }
                        isEmailVerifiedAttribute = result === null || result === void 0 || (_result$payload4 = result.payload) === null || _result$payload4 === void 0 || (_result$payload4 = _result$payload4.data) === null || _result$payload4 === void 0 ? void 0 : _result$payload4.find(function (item) { return item.Key === "IsEmailVerified"; });
                        if (isEmailVerifiedAttribute)
                            setLocalStorageItem(LOCAL_STORAGE_KEYS.IS_EMAIL_VERIFIED, isEmailVerifiedAttribute.Value);
                    }
                    getRepeatRevisitReasonListBothLevel();
                    return [2 /*return*/];
            }
        });
    }); };
    var fetchChannelSettingByKey = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _result$payload5, _result$payload6, result, _result$payload7, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: getChannelSettingByKey,
                            request: {
                                Key: "BAJAJ_AMC_POPUP_DAYS"
                            }
                        }))];
                case 1:
                    result = _a.sent();
                    if (result !== null && result !== void 0 && (_result$payload5 = result.payload) !== null && _result$payload5 !== void 0 && (_result$payload5 = _result$payload5.value) !== null && _result$payload5 !== void 0 && _result$payload5.success && result !== null && result !== void 0 && (_result$payload6 = result.payload) !== null && _result$payload6 !== void 0 && (_result$payload6 = _result$payload6.value) !== null && _result$payload6 !== void 0 && _result$payload6.data) {
                        setLocalStorageItem(LOCAL_STORAGE_KEYS.CHANNEL_SETTING_BY_KEY, result === null || result === void 0 || (_result$payload7 = result.payload) === null || _result$payload7 === void 0 || (_result$payload7 = _result$payload7.value) === null || _result$payload7 === void 0 ? void 0 : _result$payload7.data);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _a.sent();
                    console.error("Error fetching channel setting by key", error_2);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var getRepeatRevisitReasonListBothLevel = function () { return __awaiter(void 0, void 0, void 0, function () {
        var storedSelectedChannel, _result$payload8, _result$payload9, result, _result$payload10, _result$payload11, _resultHeaderLevel$pa, _resultHeaderLevel$pa2, _resultLineLevel$payl, _resultLineLevel$payl2, resultHeaderLevel, _resultHeaderLevel$pa3, resultLineLevel, _resultLineLevel$payl3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    storedSelectedChannel = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_CHANNEL);
                    if (!(storedSelectedChannel.ChannelName === E_Channel_Name.CV || storedSelectedChannel.ChannelName === E_Channel_Name.MC)) return [3 /*break*/, 2];
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: '',
                            url: getRepeatRevisitReasonListURL_MC
                        }))];
                case 1:
                    result = _a.sent();
                    if ((_result$payload8 = result.payload) !== null && _result$payload8 !== void 0 && _result$payload8.success && (_result$payload9 = result.payload) !== null && _result$payload9 !== void 0 && _result$payload9.data) {
                        setLocalStorageItem(LOCAL_STORAGE_KEYS.REPEAT_REVISIT_REASON_LIST_HEADERLEVEL, (_result$payload10 = result.payload) === null || _result$payload10 === void 0 ? void 0 : _result$payload10.data);
                        setLocalStorageItem(LOCAL_STORAGE_KEYS.REPEAT_REVISIT_REASON_LIST_LINELEVEL, (_result$payload11 = result.payload) === null || _result$payload11 === void 0 ? void 0 : _result$payload11.data);
                    }
                    _a.label = 2;
                case 2:
                    if (!(storedSelectedChannel.ChannelName === E_Channel_Name.PB || storedSelectedChannel.ChannelName === E_Channel_Name.Triumph)) return [3 /*break*/, 5];
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: '',
                            url: getRepeatRevisitReasonListURL
                        }))];
                case 3:
                    resultHeaderLevel = _a.sent();
                    if ((_resultHeaderLevel$pa = resultHeaderLevel.payload) !== null && _resultHeaderLevel$pa !== void 0 && _resultHeaderLevel$pa.success && (_resultHeaderLevel$pa2 = resultHeaderLevel.payload) !== null && _resultHeaderLevel$pa2 !== void 0 && _resultHeaderLevel$pa2.data) {
                        setLocalStorageItem(LOCAL_STORAGE_KEYS.REPEAT_REVISIT_REASON_LIST_HEADERLEVEL, (_resultHeaderLevel$pa3 = resultHeaderLevel.payload) === null || _resultHeaderLevel$pa3 === void 0 ? void 0 : _resultHeaderLevel$pa3.data);
                    }
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: '',
                            url: getRepeatRevisitReasonListURL_MC
                        }))];
                case 4:
                    resultLineLevel = _a.sent();
                    if ((_resultLineLevel$payl = resultLineLevel.payload) !== null && _resultLineLevel$payl !== void 0 && _resultLineLevel$payl.success && (_resultLineLevel$payl2 = resultLineLevel.payload) !== null && _resultLineLevel$payl2 !== void 0 && _resultLineLevel$payl2.data) {
                        setLocalStorageItem(LOCAL_STORAGE_KEYS.REPEAT_REVISIT_REASON_LIST_LINELEVEL, (_resultLineLevel$payl3 = resultLineLevel.payload) === null || _resultLineLevel$payl3 === void 0 ? void 0 : _resultLineLevel$payl3.data);
                    }
                    _a.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var getIdentityPersonalizationList = function () { return __awaiter(void 0, void 0, void 0, function () {
        var identityList_1, _result$payload12, _result$payload13, _result$payload14, result, _result$payload15, _result$payload16, _response$payload3, _response$payload4, _response$payload5, response, _response$payload6, _response$payload7, _response$payload8, _response$payload9, _response$payload10, _response$payload11, _response$payload12, _response$payload13, _response$payload14, filterChannel, filterBranch, _response$payload15, _response$payload16, _response$payload17, _response$payload18, _identityList3, _response$payload19, _filterChannel$, _response$payload22, _response$payload23, filterChannel, filterBranch, selectedChannel, selectedBranch, _response$payload20, _response$payload21, _response$payload24, _response$payload25, _response$payload26, _response$payload27, _response$payload28, _response$payload29, _response$payload30, _response$payload31, _response$payload32, _response$payload33, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 12, , 14]);
                    identityList_1 = {};
                    if (!!(storedIdentityPersonalizationList !== null && storedIdentityPersonalizationList !== void 0 && storedIdentityPersonalizationList.IdentityPersonalizationId)) return [3 /*break*/, 4];
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "",
                            url: getIdentityPersonalizationListUrl
                        }))];
                case 1:
                    result = _a.sent();
                    if (!((result === null || result === void 0 || (_result$payload12 = result.payload) === null || _result$payload12 === void 0 ? void 0 : _result$payload12.statusCode) === 200 && result !== null && result !== void 0 && (_result$payload13 = result.payload) !== null && _result$payload13 !== void 0 && _result$payload13.success && (result === null || result === void 0 || (_result$payload14 = result.payload) === null || _result$payload14 === void 0 ? void 0 : _result$payload14.data.length) > 0)) return [3 /*break*/, 3];
                    setLocalStorageItem(LOCAL_STORAGE_KEYS.IDENTITY_PERSONALIZATION_LIST, result === null || result === void 0 || (_result$payload15 = result.payload) === null || _result$payload15 === void 0 ? void 0 : _result$payload15.data[0]);
                    identityList_1 = result === null || result === void 0 || (_result$payload16 = result.payload) === null || _result$payload16 === void 0 ? void 0 : _result$payload16.data[0].Value;
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [3 /*break*/, 5];
                case 4:
                    identityList_1 = storedIdentityPersonalizationList === null || storedIdentityPersonalizationList === void 0 ? void 0 : storedIdentityPersonalizationList.Value;
                    _a.label = 5;
                case 5:
                    if (!(storedChannelList == null)) return [3 /*break*/, 11];
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: true
                        }))];
                case 6:
                    _a.sent();
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "",
                            url: getBranchChannelUrl
                        }))];
                case 7:
                    response = _a.sent();
                    if (!(response !== null && response !== void 0 && (_response$payload3 = response.payload) !== null && _response$payload3 !== void 0 && _response$payload3.success && (response === null || response === void 0 || (_response$payload4 = response.payload) === null || _response$payload4 === void 0 ? void 0 : _response$payload4.statusCode) == 200 && (response === null || response === void 0 || (_response$payload5 = response.payload) === null || _response$payload5 === void 0 ? void 0 : _response$payload5.data.length) > 0)) return [3 /*break*/, 10];
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 8:
                    _a.sent();
                    if ((response === null || response === void 0 || (_response$payload6 = response.payload) === null || _response$payload6 === void 0 || (_response$payload6 = _response$payload6.data) === null || _response$payload6 === void 0 ? void 0 : _response$payload6.length) === 1) {
                        setLocalStorageItem(LOCAL_STORAGE_KEYS.CHANNEL_LIST, response === null || response === void 0 || (_response$payload7 = response.payload) === null || _response$payload7 === void 0 ? void 0 : _response$payload7.data);
                        dispatch(setBranchChannelList({
                            getBranchChannelList: response === null || response === void 0 || (_response$payload8 = response.payload) === null || _response$payload8 === void 0 ? void 0 : _response$payload8.data
                        }));
                        filterChannel = response === null || response === void 0 || (_response$payload9 = response.payload) === null || _response$payload9 === void 0 || (_response$payload9 = _response$payload9.data) === null || _response$payload9 === void 0 ? void 0 : _response$payload9.filter(function (item) {
                            var _identityList;
                            return item.ChannelId == ((_identityList = identityList_1) === null || _identityList === void 0 || (_identityList = _identityList.ChannelDetails) === null || _identityList === void 0 ? void 0 : _identityList.ChannelId);
                        });
                        filterBranch = response === null || response === void 0 || (_response$payload10 = response.payload) === null || _response$payload10 === void 0 || (_response$payload10 = _response$payload10.data[0]) === null || _response$payload10 === void 0 || (_response$payload10 = _response$payload10.BranchDetails) === null || _response$payload10 === void 0 ? void 0 : _response$payload10.filter(function (item) {
                            var _identityList2;
                            return item.OrganizationId == ((_identityList2 = identityList_1) === null || _identityList2 === void 0 || (_identityList2 = _identityList2.BranchDetails) === null || _identityList2 === void 0 ? void 0 : _identityList2.OrganizationId);
                        });
                        setLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_CHANNEL, filterChannel[0] ? filterChannel[0] : response === null || response === void 0 || (_response$payload11 = response.payload) === null || _response$payload11 === void 0 ? void 0 : _response$payload11.data[0]);
                        setLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH, filterBranch[0] ? filterBranch[0] : response === null || response === void 0 || (_response$payload12 = response.payload) === null || _response$payload12 === void 0 ? void 0 : _response$payload12.data[0].BranchDetails[0]);
                        getOrganizationTiming(filterBranch[0] ? filterBranch[0] : response === null || response === void 0 || (_response$payload13 = response.payload) === null || _response$payload13 === void 0 ? void 0 : _response$payload13.data[0].BranchDetails[0]);
                        getChannelSettingsNew(filterBranch[0] ? filterBranch[0] : response === null || response === void 0 || (_response$payload14 = response.payload) === null || _response$payload14 === void 0 ? void 0 : _response$payload14.data[0].BranchDetails[0]);
                        getSettingsByChannel();
                        if (filterChannel.length === 0 || filterBranch.length === 0) {
                            saveChannelData(response === null || response === void 0 || (_response$payload15 = response.payload) === null || _response$payload15 === void 0 ? void 0 : _response$payload15.data[0], response === null || response === void 0 || (_response$payload16 = response.payload) === null || _response$payload16 === void 0 ? void 0 : _response$payload16.data[0].BranchDetails[0]);
                        }
                        else {
                            if (Module === isModuleConfig.Product) {
                                //Changing for bajaj release
                                getProductIssueConfiguration(response === null || response === void 0 || (_response$payload17 = response.payload) === null || _response$payload17 === void 0 || (_response$payload17 = _response$payload17.data[0].BranchDetails[0]) === null || _response$payload17 === void 0 ? void 0 : _response$payload17.OrganizationId, response === null || response === void 0 || (_response$payload18 = response.payload) === null || _response$payload18 === void 0 || (_response$payload18 = _response$payload18.data[0]) === null || _response$payload18 === void 0 ? void 0 : _response$payload18.ChannelId);
                            }
                        }
                        //navigate('/dashboard')
                    }
                    else {
                        if ((_identityList3 = identityList_1) !== null && _identityList3 !== void 0 && _identityList3.ChannelDetails) {
                            filterChannel = response === null || response === void 0 || (_response$payload19 = response.payload) === null || _response$payload19 === void 0 || (_response$payload19 = _response$payload19.data) === null || _response$payload19 === void 0 ? void 0 : _response$payload19.filter(function (item) {
                                var _identityList4;
                                return item.ChannelId == ((_identityList4 = identityList_1) === null || _identityList4 === void 0 || (_identityList4 = _identityList4.ChannelDetails) === null || _identityList4 === void 0 ? void 0 : _identityList4.ChannelId);
                            });
                            filterBranch = (_filterChannel$ = filterChannel[0]) === null || _filterChannel$ === void 0 || (_filterChannel$ = _filterChannel$.BranchDetails) === null || _filterChannel$ === void 0 ? void 0 : _filterChannel$.filter(function (item) {
                                var _identityList5;
                                return item.OrganizationId == ((_identityList5 = identityList_1) === null || _identityList5 === void 0 || (_identityList5 = _identityList5.BranchDetails) === null || _identityList5 === void 0 ? void 0 : _identityList5.OrganizationId);
                            });
                            selectedChannel = void 0;
                            selectedBranch = void 0;
                            if (filterChannel.length === 0) {
                                selectedChannel = response === null || response === void 0 || (_response$payload20 = response.payload) === null || _response$payload20 === void 0 ? void 0 : _response$payload20.data[0];
                                selectedBranch = response === null || response === void 0 || (_response$payload21 = response.payload) === null || _response$payload21 === void 0 ? void 0 : _response$payload21.data[0].BranchDetails[0];
                            }
                            else if (filterChannel.length > 0 && filterBranch.length === 0) {
                                selectedChannel = filterChannel[0];
                                selectedBranch = filterChannel[0].BranchDetails[0];
                            }
                            else {
                                selectedChannel = filterChannel[0];
                                selectedBranch = filterBranch[0];
                            }
                            dispatch(setBranchChannelList({
                                getBranchChannelList: response === null || response === void 0 || (_response$payload22 = response.payload) === null || _response$payload22 === void 0 ? void 0 : _response$payload22.data,
                                selectedBranchChannel: selectedChannel
                            }));
                            setLocalStorageItem(LOCAL_STORAGE_KEYS.CHANNEL_LIST, response === null || response === void 0 || (_response$payload23 = response.payload) === null || _response$payload23 === void 0 ? void 0 : _response$payload23.data);
                            setLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_CHANNEL, selectedChannel);
                            setLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH, selectedBranch);
                            saveChannelData(selectedChannel, selectedBranch);
                            getOrganizationTiming(selectedBranch);
                            getChannelSettingsNew(selectedBranch);
                            getSettingsByChannel();
                        }
                        else {
                            setLocalStorageItem(LOCAL_STORAGE_KEYS.CHANNEL_LIST, response === null || response === void 0 || (_response$payload24 = response.payload) === null || _response$payload24 === void 0 ? void 0 : _response$payload24.data);
                            dispatch(setBranchChannelList({
                                getBranchChannelList: response === null || response === void 0 || (_response$payload25 = response.payload) === null || _response$payload25 === void 0 ? void 0 : _response$payload25.data,
                                selectedBranchChannel: response === null || response === void 0 || (_response$payload26 = response.payload) === null || _response$payload26 === void 0 ? void 0 : _response$payload26.data[0]
                            }));
                            setLocalStorageItem(LOCAL_STORAGE_KEYS.CHANNEL_LIST, response === null || response === void 0 || (_response$payload27 = response.payload) === null || _response$payload27 === void 0 ? void 0 : _response$payload27.data);
                            setLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_CHANNEL, response === null || response === void 0 || (_response$payload28 = response.payload) === null || _response$payload28 === void 0 ? void 0 : _response$payload28.data[0]);
                            setLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH, response === null || response === void 0 || (_response$payload29 = response.payload) === null || _response$payload29 === void 0 ? void 0 : _response$payload29.data[0].BranchDetails[0]);
                            getOrganizationTiming(response === null || response === void 0 || (_response$payload30 = response.payload) === null || _response$payload30 === void 0 ? void 0 : _response$payload30.data[0].BranchDetails[0]);
                            getChannelSettingsNew(response === null || response === void 0 || (_response$payload31 = response.payload) === null || _response$payload31 === void 0 ? void 0 : _response$payload31.data[0].BranchDetails[0]);
                            getSettingsByChannel();
                            saveChannelData(response === null || response === void 0 || (_response$payload32 = response.payload) === null || _response$payload32 === void 0 ? void 0 : _response$payload32.data[0], response === null || response === void 0 || (_response$payload33 = response.payload) === null || _response$payload33 === void 0 ? void 0 : _response$payload33.data[0].BranchDetails[0]);
                        }
                        //navigate('/dashboard')
                    }
                    dispatch(showNotification({
                        isOpen: true,
                        message: t("Logged in successfully"),
                        type: "success"
                    }));
                    // buttonClickSpan.end();
                    // pageLoadSpan.end();
                    // transaction.end();
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 9:
                    // buttonClickSpan.end();
                    // pageLoadSpan.end();
                    // transaction.end();
                    _a.sent();
                    navigate("/dashboard");
                    return [3 /*break*/, 11];
                case 10:
                    setOpenUnauthorizedPopup(true);
                    _a.label = 11;
                case 11: return [3 /*break*/, 14];
                case 12:
                    e_1 = _a.sent();
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 13:
                    _a.sent();
                    console.log("Error-", e_1);
                    return [3 /*break*/, 14];
                case 14: return [2 /*return*/];
            }
        });
    }); };
    var getServiceTypeList = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _response$payload34, _response$payload35, _response$payload36, request, response, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    request = {
                        Key: "AllowServiceTypeChangeConfiguration"
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: 'serviceTypeList',
                            url: ServiceTypeListURL,
                            request: request
                        }))];
                case 1:
                    response = _a.sent();
                    if (response !== null && response !== void 0 && (_response$payload34 = response.payload) !== null && _response$payload34 !== void 0 && (_response$payload34 = _response$payload34.value) !== null && _response$payload34 !== void 0 && _response$payload34.success || (response === null || response === void 0 || (_response$payload35 = response.payload) === null || _response$payload35 === void 0 || (_response$payload35 = _response$payload35.value) === null || _response$payload35 === void 0 ? void 0 : _response$payload35.code) === 200)
                        setLocalStorageItem(LOCAL_STORAGE_KEYS.SERVICE_TYPES, response === null || response === void 0 || (_response$payload36 = response.payload) === null || _response$payload36 === void 0 || (_response$payload36 = _response$payload36.value) === null || _response$payload36 === void 0 ? void 0 : _response$payload36.data);
                    return [3 /*break*/, 3];
                case 2:
                    error_3 = _a.sent();
                    console.error(error_3);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var saveChannelData = function (selectedChannel, selectedBranch) { return __awaiter(void 0, void 0, void 0, function () {
        var _response$payload37, _response$payload38, _response$payload39, payload, response, _response$payload40, data, _data$BranchDetails, _data$ChannelDetails;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    payload = {
                        selectedBranchChannel: selectedChannel,
                        selectedBranchData: selectedBranch
                    };
                    return [4 /*yield*/, dispatch(saveChannelIdDetails(payload))];
                case 1:
                    response = _a.sent();
                    if (response !== null && response !== void 0 && (_response$payload37 = response.payload) !== null && _response$payload37 !== void 0 && (_response$payload37 = _response$payload37.payload) !== null && _response$payload37 !== void 0 && _response$payload37.success && (response === null || response === void 0 || (_response$payload38 = response.payload) === null || _response$payload38 === void 0 || (_response$payload38 = _response$payload38.payload) === null || _response$payload38 === void 0 ? void 0 : _response$payload38.statusCode) == 200 && response !== null && response !== void 0 && (_response$payload39 = response.payload) !== null && _response$payload39 !== void 0 && (_response$payload39 = _response$payload39.payload) !== null && _response$payload39 !== void 0 && (_response$payload39 = _response$payload39.data) !== null && _response$payload39 !== void 0 && _response$payload39.Value) {
                        data = response === null || response === void 0 || (_response$payload40 = response.payload) === null || _response$payload40 === void 0 || (_response$payload40 = _response$payload40.payload) === null || _response$payload40 === void 0 || (_response$payload40 = _response$payload40.data) === null || _response$payload40 === void 0 ? void 0 : _response$payload40.Value;
                        if (Module === isModuleConfig.Product) {
                            //Changing for bajaj release
                            getProductIssueConfiguration(data === null || data === void 0 || (_data$BranchDetails = data.BranchDetails) === null || _data$BranchDetails === void 0 ? void 0 : _data$BranchDetails.OrganizationId, data === null || data === void 0 || (_data$ChannelDetails = data.ChannelDetails) === null || _data$ChannelDetails === void 0 ? void 0 : _data$ChannelDetails.ChannelId);
                        }
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getProductIssueConfiguration = function (organizationId, channelId) { return __awaiter(void 0, void 0, void 0, function () {
        var _result$payload17, _result$payload18, _result$payload19, request, result, _result$payload20, _multipleDocArray$Val, _multipleDocArray, multipleDocArray, multipleDocValue;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = {
                        OrganizationId: organizationId !== null && organizationId !== void 0 ? organizationId : '',
                        ChannelId: channelId !== null && channelId !== void 0 ? channelId : ''
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: getProductIssueConfigurationURL,
                            request: request
                        }))];
                case 1:
                    result = _a.sent();
                    if (result !== null && result !== void 0 && (_result$payload17 = result.payload) !== null && _result$payload17 !== void 0 && (_result$payload17 = _result$payload17.value) !== null && _result$payload17 !== void 0 && _result$payload17.success && (result === null || result === void 0 || (_result$payload18 = result.payload) === null || _result$payload18 === void 0 || (_result$payload18 = _result$payload18.value) === null || _result$payload18 === void 0 ? void 0 : _result$payload18.statusCode) == 200 && (result === null || result === void 0 || (_result$payload19 = result.payload) === null || _result$payload19 === void 0 || (_result$payload19 = _result$payload19.value) === null || _result$payload19 === void 0 || (_result$payload19 = _result$payload19.data) === null || _result$payload19 === void 0 || (_result$payload19 = _result$payload19.AllocationSubTypes) === null || _result$payload19 === void 0 ? void 0 : _result$payload19.length) > 0) {
                        multipleDocArray = [];
                        multipleDocArray = result === null || result === void 0 || (_result$payload20 = result.payload) === null || _result$payload20 === void 0 || (_result$payload20 = _result$payload20.value) === null || _result$payload20 === void 0 || (_result$payload20 = _result$payload20.data) === null || _result$payload20 === void 0 ? void 0 : _result$payload20.AllocationSubTypes.find(function (item) { return item.Key === SPARE_ISSUE_ENUM.MultipleDocument; });
                        multipleDocValue = (_multipleDocArray$Val = (_multipleDocArray = multipleDocArray) === null || _multipleDocArray === void 0 ? void 0 : _multipleDocArray.Value) !== null && _multipleDocArray$Val !== void 0 ? _multipleDocArray$Val : false;
                        setLocalStorageItem(LOCAL_STORAGE_KEYS.SPARE_ISSUE_MULTIPLE_DOC, multipleDocValue);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleRedirection = function () {
        window.open("https://www.excellonsoft.com/", "_blank"); // Open the URL in a new tab
    };
    var getDeclineJobConfig = function (reqBody) { return __awaiter(void 0, void 0, void 0, function () {
        var _result$payload21, _result$payload22, result, _result$payload23;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(getListAPI({
                        key: "",
                        url: DeclinedJobConfigurationSettingURL,
                        request: reqBody
                    }))];
                case 1:
                    result = _a.sent();
                    if (result !== null && result !== void 0 && (_result$payload21 = result.payload) !== null && _result$payload21 !== void 0 && (_result$payload21 = _result$payload21.value) !== null && _result$payload21 !== void 0 && _result$payload21.success && result !== null && result !== void 0 && (_result$payload22 = result.payload) !== null && _result$payload22 !== void 0 && (_result$payload22 = _result$payload22.value) !== null && _result$payload22 !== void 0 && _result$payload22.data) {
                        setLocalStorageItem(LOCAL_STORAGE_KEYS === null || LOCAL_STORAGE_KEYS === void 0 ? void 0 : LOCAL_STORAGE_KEYS.DECLINED_JOB_CONFIGURATION, result === null || result === void 0 || (_result$payload23 = result.payload) === null || _result$payload23 === void 0 || (_result$payload23 = _result$payload23.value) === null || _result$payload23 === void 0 ? void 0 : _result$payload23.data);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getDelayJobCardConfig = function (reqBody) { return __awaiter(void 0, void 0, void 0, function () {
        var _result$payload24, _result$payload25, result, _result$payload26;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(getListAPI({
                        key: "",
                        url: getDelayJobCardConfigurationURL,
                        request: reqBody
                    }))];
                case 1:
                    result = _a.sent();
                    if (result !== null && result !== void 0 && (_result$payload24 = result.payload) !== null && _result$payload24 !== void 0 && (_result$payload24 = _result$payload24.value) !== null && _result$payload24 !== void 0 && _result$payload24.success && result !== null && result !== void 0 && (_result$payload25 = result.payload) !== null && _result$payload25 !== void 0 && (_result$payload25 = _result$payload25.value) !== null && _result$payload25 !== void 0 && _result$payload25.data) {
                        setLocalStorageItem(LOCAL_STORAGE_KEYS === null || LOCAL_STORAGE_KEYS === void 0 ? void 0 : LOCAL_STORAGE_KEYS.DELAY_JOB_CARD_CONFIGURATION, result === null || result === void 0 || (_result$payload26 = result.payload) === null || _result$payload26 === void 0 || (_result$payload26 = _result$payload26.value) === null || _result$payload26 === void 0 ? void 0 : _result$payload26.data);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getAlternatePartConfig = function (reqBody) { return __awaiter(void 0, void 0, void 0, function () {
        var _result$payload27, _result$payload28, result, _result$payload29;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(getListAPI({
                        key: "",
                        url: AlternatePartConfigUrl,
                        request: reqBody
                    }))];
                case 1:
                    result = _a.sent();
                    if (result !== null && result !== void 0 && (_result$payload27 = result.payload) !== null && _result$payload27 !== void 0 && (_result$payload27 = _result$payload27.value) !== null && _result$payload27 !== void 0 && _result$payload27.success && result !== null && result !== void 0 && (_result$payload28 = result.payload) !== null && _result$payload28 !== void 0 && (_result$payload28 = _result$payload28.value) !== null && _result$payload28 !== void 0 && _result$payload28.data) {
                        setLocalStorageItem(LOCAL_STORAGE_KEYS === null || LOCAL_STORAGE_KEYS === void 0 ? void 0 : LOCAL_STORAGE_KEYS.ALTERNATE_PART_CONFIG, result === null || result === void 0 || (_result$payload29 = result.payload) === null || _result$payload29 === void 0 || (_result$payload29 = _result$payload29.value) === null || _result$payload29 === void 0 ? void 0 : _result$payload29.data);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getChannelSettingsNew = function (organizationDetails) { return __awaiter(void 0, void 0, void 0, function () {
        var req;
        return __generator(this, function (_a) {
            req = {
                OrganizationId: organizationDetails.OrganizationId
            };
            getAlternatePartConfig(req);
            getDelayJobCardConfig(req);
            return [2 /*return*/];
        });
    }); };
    var onCloseUnauthorizedAccessPopup = function () {
        dispatch(resetCommonReducer());
        clearLocalStorage();
        whoamiApi();
        setMobileNo("");
        setOpt("");
        setCounter(0);
        var profileData = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA);
        GoogleAnlyticsErrorLog(profileData, 'ClientSide', t("Unauthorized"));
        setOpenUnauthorizedPopup(false);
    };
    return /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        bgcolor: "white"
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 0,
        md: 7,
        lg: 8,
        sx: {
            height: "100svh",
            overflow: "hidden"
        },
        display: {
            xs: "none",
            md: "block"
        }
    }, /*#__PURE__*/ React.createElement(SliderCarousel, null)), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        md: 5,
        lg: 4,
        height: "100svh"
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        height: "100%",
        alignItems: "center"
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        height: "100%",
        p: {
            xs: 2,
            sm: 2.5,
            md: 3
        },
        justifyContent: 'space-between',
        maxWidth: 500
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        mt: 5
    }, Module === isModuleConfig.Bajaj ? /*#__PURE__*/ React.createElement(React.Fragment, null, IS_MOBILE ? /*#__PURE__*/ React.createElement(BajajDrawerLogoIcon, {
        sx: {
            height: '36px',
            width: '78px'
        }
    }) : /*#__PURE__*/ React.createElement(BajajDrawerLogoIcon, {
        sx: {
            height: '72px',
            width: '156px'
        }
    })) : /*#__PURE__*/ React.createElement(BrandLogoIcon, {
        fontSize: "large",
        style: {
            width: '180px',
            display: 'flex',
            color: 'black'
        }
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        flexGrow: 1
    }, /*#__PURE__*/ React.createElement(LoginForm, {
        onSubmit: handleSignInClick
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 24,
        lineHeight: '32px',
        fontWeight: "strong"
    }, "  ", t("Log in")), /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "lg",
        color: "text.tertiary",
        pt: 1
    }, t("Log in to better track and manage your job cards"))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        pt: 4
    }, /*#__PURE__*/ React.createElement(Stack, {
        gap: 0.75
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontWeight: "medium",
        fontSize: "base"
    }, t("Mobile number")), /*#__PURE__*/ React.createElement(TextField, {
        id: "mobileNo",
        placeholder: t("Enter mobile number"),
        size: "medium",
        value: mobileNumber,
        error: isErrorOccure,
        onChange: handleOnChange,
        helperText: errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.isValidMobileNumber,
        fullWidth: true,
        inputProps: {
            inputMode: 'tel',
            pattern: "[0-9]*",
            maxLength: 10
        },
        InputProps: {
            endAdornment: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Divider, {
                orientation: "vertical",
                flexItem: true
            }), !isOtpSent ? /*#__PURE__*/ React.createElement(MuiLoaderButton, {
                id: "otpButton",
                name: t("Send OTP"),
                loading: loader.isLoaderOpen,
                variant: "text",
                size: "medium",
                onClick: function (e) { return handleLogin(e, 'send'); },
                disabled: !(mobileNumber.length == 10 && mobileNumber.charAt(0) != '0')
            }) : counter <= 0 ? /*#__PURE__*/ React.createElement(Button, {
                id: "resendOtp",
                variant: "text",
                size: "medium",
                sx: {
                    textWrap: 'nowrap'
                },
                onClick: function (e) { return handleLogin(e, 'resend'); },
                disabled: !mobileNumber,
                disableFocusRipple: true,
                disableTouchRipple: true
            }, t("Resend OTP")) : /*#__PURE__*/ React.createElement(Typography, {
                id: "otpTimer",
                variant: "h3",
                align: "center",
                color: systemColor.primary
            }, formatTime(counter)))
        },
        autoComplete: "mobile"
    }))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        pt: 2.5
    }, /*#__PURE__*/ React.createElement(Stack, {
        gap: 0.75
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontWeight: "medium",
        fontSize: "base"
    }, t("OTP")), /*#__PURE__*/ React.createElement(TextField, {
        id: "enterOtp",
        placeholder: t("Enter OTP"),
        size: "medium",
        value: otp,
        error: isErrorOccureOtp,
        onChange: handleOTPChange,
        helperText: errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.isValidOTP,
        fullWidth: true,
        inputProps: {
            inputMode: "numeric",
            pattern: "[0-9]*"
        },
        disabled: !isCounterActive
    }))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        pt: 3
    }, /*#__PURE__*/ React.createElement(MuiLoaderButton, {
        id: "signInButton",
        loading: loader.isLoaderOpen,
        variant: "contained",
        size: "large",
        color: "primary",
        name: t("SIGN_IN_BUTTON"),
        disabled: SetDiable(),
        fullWidth: true,
        type: "submit"
    })))))), /*#__PURE__*/ React.createElement(TimeZoneDialog, {
        isOpen: showPopup,
        onClose: handleRemindLater,
        handleConfirmClick: handleUpdate,
        handleDiscardClick: handleRemindLater,
        detectedOffset: timeZoneCheck === null || timeZoneCheck === void 0 ? void 0 : timeZoneCheck.offset,
        detectedZone: timeZoneCheck === null || timeZoneCheck === void 0 ? void 0 : timeZoneCheck.detectedZone,
        expectedOffset: expectedOffset,
        expectedLabel: expectedLabel
    }), /*#__PURE__*/ React.createElement(MuiStack, {
        width: "100%",
        position: 'relative'
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
        px: 2,
        pb: 4
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        columnGap: 1,
        alignItems: 'center',
        sx: {
            cursor: 'pointer'
        },
        onClick: handleRedirection
    }, /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement("img", {
        width: 40,
        height: 40,
        src: ExcellonLogo,
        alt: "excellon-logo",
        id: "excellon-logo"
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column'
    }, /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "xl",
        color: "text.tertiary",
        fontWeight: "strong"
    }, t("Powered by Excellon"))), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Typography, {
        color: "text.disabled"
    }, versionNum.version)))))))), openUnauthorizedPopup && /*#__PURE__*/ React.createElement(MuiPopup, {
        variant: "h1",
        openPopup: openUnauthorizedPopup,
        closeIcon: true,
        backdropEnable: true,
        onClose: onCloseUnauthorizedAccessPopup,
        padding: '15px 0px 0px 15px',
        headerIcon: AlertRedIcon
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 1.5
    }, /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h2"
    }, t('Unauthorized Access'))), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h4",
        color: '#6A7682',
        marginTop: 1
    }, t("You are not authorized to log in to the application. Please contact the support team for assistance."))), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column'
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 1,
        alignItems: 'center'
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "caption"
    }, t('Email'), ": "), /*#__PURE__*/ React.createElement(MuiButton, {
        size: "small",
        variant: "text",
        name: "balcdmshelpdesk@excellonsoft.com",
        onClick: function () {
            // const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=support@example.com&su=Support Request&body=Hello, I need help with...`;
            // window.open(gmailUrl, '_blank');
            window.location.href = 'mailto:balcdmshelpdesk@excellonsoft.com?subject=Support Request&body=Hello, I need help with...';
        }
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 1,
        alignItems: 'center'
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "caption"
    }, t('Phone'), ": "), /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: 'center'
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        variant: "text",
        name: "07126699611",
        size: "small",
        onClick: function (event) {
            event.stopPropagation();
            handleMobileNoPhoneCall(Number('07126699611'));
        }
    }), /*#__PURE__*/ React.createElement(Typography, null, "/"), /*#__PURE__*/ React.createElement(MuiButton, {
        variant: "text",
        name: "07126699612",
        onClick: function (event) {
            event.stopPropagation();
            handleMobileNoPhoneCall(Number('07126699612'));
        }
    })))), /*#__PURE__*/ React.createElement(MuiStack, {
        width: '100%'
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        fullWidth: true,
        id: "confirmButton",
        variant: "contained",
        size: "small",
        color: "primary",
        name: t("OK"),
        onClick: onCloseUnauthorizedAccessPopup
    })))));
};
export default Login;
